const WALLET_RETURN_CONTEXT_KEY = 'wassla.wallet.return.context.v1';
const PAGE_VIEW_STATE_PREFIX = 'wassla.page.view.state.v1.';

const getMainScrollTop = () => {
  if (typeof document === 'undefined') return 0;
  const container = document.querySelector('.main-content');
  if (container && typeof container.scrollTop === 'number') {
    return container.scrollTop;
  }
  return typeof window !== 'undefined' ? (window.scrollY || 0) : 0;
};

export function markWalletReturnContext(pathname) {
  if (typeof window === 'undefined' || !pathname) return;

  const payload = {
    pathname,
    scrollTop: getMainScrollTop(),
    ts: Date.now(),
  };

  sessionStorage.setItem(WALLET_RETURN_CONTEXT_KEY, JSON.stringify(payload));
}

export function consumeWalletReturnContext(pathname) {
  if (typeof window === 'undefined' || !pathname) return null;

  const raw = sessionStorage.getItem(WALLET_RETURN_CONTEXT_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);

    // Expire stale contexts after 10 minutes
    if (!parsed?.ts || Date.now() - parsed.ts > 10 * 60 * 1000) {
      sessionStorage.removeItem(WALLET_RETURN_CONTEXT_KEY);
      return null;
    }

    if (parsed?.pathname === pathname) {
      sessionStorage.removeItem(WALLET_RETURN_CONTEXT_KEY);
      return parsed;
    }

    return null;
  } catch {
    sessionStorage.removeItem(WALLET_RETURN_CONTEXT_KEY);
    return null;
  }
}

export function savePageViewState(pageKey, state) {
  if (typeof window === 'undefined' || !pageKey) return;
  try {
    sessionStorage.setItem(`${PAGE_VIEW_STATE_PREFIX}${pageKey}`, JSON.stringify(state || {}));
  } catch {
    // ignore quota/storage errors
  }
}

export function loadPageViewState(pageKey) {
  if (typeof window === 'undefined' || !pageKey) return null;
  try {
    const raw = sessionStorage.getItem(`${PAGE_VIEW_STATE_PREFIX}${pageKey}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
